import React, { useState, useEffect, Key } from 'react';
import { Button, Select } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';
import { MultipleSelectSearchActionsOption } from './_multiple-select-search-actions-option';
import { Icon } from '@common/components';

type SelectValue = string | number | Key;

export const MultipleSelectSearch = ({
  options,
  onSearch,
  value = [],
  ...props
}: {
  onSearch: (query: SelectValue[]) => void;
  options: {
    label: React.ReactNode | string;
    value: SelectValue;
  }[];
  value?: SelectValue[];
}) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  function removeItem(itemToBeRemoved: SelectValue) {
    const newList = [...internalValue];
    const itemToBeRemovedIndex = newList.indexOf(itemToBeRemoved);

    newList.splice(itemToBeRemovedIndex, 1);
    setInternalValue(newList);
  }

  function addUniqueItem(newValue: SelectValue) {
    if (!internalValue.includes(newValue)) {
      setInternalValue([...internalValue, newValue]);
    }
  }

  function addAllItems() {
    const all = options.map((o) => o.value);
    setInternalValue(all);
  }

  function removeAllItems() {
    setInternalValue([]);
  }

  // FIXME: I'm not sure if fixing this will make styles incorrect, hence the cast.
  const castSize = 'medium' as 'middle';

  return (
    <>
      <div className="multiple-select-search">
        <div className="multiple-select-search__select">
          <Select
            mode="multiple"
            options={[
              {
                label: (
                  <MultipleSelectSearchActionsOption
                    addAll={addAllItems}
                    removeAll={removeAllItems}
                  />
                ),
                value: 'skip',
                disabled: true,
              },
              ...options,
            ]}
            value={internalValue as unknown as SelectValue}
            placeholder="Search"
            optionFilterProp="label"
            onSelect={addUniqueItem}
            onChange={addUniqueItem}
            onDeselect={removeItem}
            {...props}
          />
          <button
            className="multiple-select-search__clear-button"
            onClick={removeAllItems}
          >
            <Icon icon="xmarkCircle" size="sm" />
          </button>
        </div>
        <Button
          className="multiple-select-search__button"
          type="primary"
          size={castSize}
          onClick={() => {
            onSearch(internalValue);
            removeAllItems();
          }}
        >
          Apply
        </Button>
      </div>
      <style jsx>{`
        .multiple-select-search {
          display: flex;
        }
        .multiple-select-search__clear-button {
          position: absolute;
          right: 3px;
          top: calc(50% - 12px);
          background-color: transparent;
          border: none;
          outline: none;
          cursor: pointer;
          color: ${Colors.steelDarker};
          opacity: 0;
          transition:
            opacity,
            color 0.3s ease-in-out;
        }
        .multiple-select-search:hover .multiple-select-search__clear-button {
          opacity: 1;
        }
        .multiple-select-search__clear-button:hover {
          color: ${Colors.steelDarkest};
        }
        .multiple-select-search__select {
          position: relative;
          width: 300px;
        }
        :global(.multiple-select-search__select .ant-select) {
          display: block;
        }
        :global(.multiple-select-search__button) {
          width: 90px;
          margin-left: 15px;
        }
      `}</style>
    </>
  );
};
